import { render, staticRenderFns } from "./imperfekt-av-starka-verb.vue?vue&type=template&id=67ce6540&scoped=true"
import script from "./imperfekt-av-starka-verb.vue?vue&type=script&lang=js"
export * from "./imperfekt-av-starka-verb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce6540",
  null
  
)

export default component.exports